import React from 'react';
import { useTranslation } from 'react-i18next';

export const ChecksumColumns = () => {
    const { t } = useTranslation();

    return [
        {
            title: t('gameId'),
            label: 'gameId',
            dataIndex: 'gameId',
            key: 'gameId',
            width: 100,
            fixed: true,
            render: (text: string) => <span>{`rp_${text}`}</span>,
        },
        {
            title: t('gameName'),
            label: 'gamename',
            dataIndex: 'gameName',
            key: 'gameName',
        },
        {
            title: t('rtp'),
            label: 'rtp',
            dataIndex: 'rtp',
            key: 'rtp',
            width: 100,
        },
        {
            title: t('fileName'),
            label: 'fileName',
            dataIndex: 'fileName',
            key: 'fileName',
            width: 280,
        },
        {
            title: 'File Version',
            label: 'fileVersion',
            dataIndex: 'fileName',
            key: 'fileName',
            width: 160,
            render: (text: string) => {
                const versionMatch = text.match(/\d+\.\d+\.\d+/);
                return <span>{versionMatch ? versionMatch[0] : ''}</span>;
            },
        },
        {
            title: 'Algorithm Type',
            label: 'hashingAlgorithm',
            dataIndex: 'hashingAlgorithm',
            key: 'hashingAlgorithm',
            width: 160,
        },
        {
            title: 'Hash',
            label: 'hash',
            dataIndex: 'hash',
            key: 'hash',
        },
    ];
};
